import store from '@/store/store'
const version = require('element-ui/package.json').version // element-ui version from node_modules
const ORIGINAL_THEME = '#409EFF' // default color

var chalk = ''

// 动态切换主题色
export function changeThemeColor (newColor) {
  const updateStyle = (style, oldCluster, newCluster) => {
    let newStyle = style
    oldCluster.forEach((color, index) => {
      newStyle = newStyle.replace(new RegExp(color, 'ig'), newCluster[index])
    })
    return newStyle
  }

  const getCSSString = (url) => {
    return new Promise(resolve => {
      const xhr = new XMLHttpRequest()
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
          resolve(xhr.responseText.replace(/@font-face{[^}]+}/, ''))
        }
      }
      xhr.open('GET', url)
      xhr.send()
    })
  }

  const getThemeCluster = (theme) => {
    const tintColor = (color, tint) => {
      let red = parseInt(color.slice(0, 2), 16)
      let green = parseInt(color.slice(2, 4), 16)
      let blue = parseInt(color.slice(4, 6), 16)

      if (tint === 0) { // when primary color is in its rgb space
        return [red, green, blue].join(',')
      } else {
        red += Math.round(tint * (255 - red))
        green += Math.round(tint * (255 - green))
        blue += Math.round(tint * (255 - blue))

        red = red.toString(16)
        green = green.toString(16)
        blue = blue.toString(16)

        return `#${red}${green}${blue}`
      }
    }

    const shadeColor = (color, shade) => {
      let red = parseInt(color.slice(0, 2), 16)
      let green = parseInt(color.slice(2, 4), 16)
      let blue = parseInt(color.slice(4, 6), 16)

      red = Math.round((1 - shade) * red)
      green = Math.round((1 - shade) * green)
      blue = Math.round((1 - shade) * blue)

      red = red.toString(16)
      green = green.toString(16)
      blue = blue.toString(16)

      return `#${red}${green}${blue}`
    }

    const clusters = [theme]
    for (let i = 0; i <= 9; i++) {
      clusters.push(tintColor(theme, Number((i / 10).toFixed(2))))
    }
    clusters.push(shadeColor(theme, 0.1))
    
    return clusters
  }

  const getHandler = (variable, id, themeCluster) => {
    return () => {
      const originalCluster = getThemeCluster(ORIGINAL_THEME.replace('#', ''))
      const newStyle = updateStyle(variable, originalCluster, themeCluster)

      let styleTag = document.getElementById(id)
      if (!styleTag) {
        styleTag = document.createElement('style')
        styleTag.setAttribute('id', id)
        document.head.appendChild(styleTag)
      }
      styleTag.innerText = newStyle
    }
  }

  return new Promise(function (resolve, reject) {
    if (!chalk) {
      // const url = `https://unpkg.com/element-ui@${version}/lib/theme-chalk/index.css`
      const url = `https://zhonglejia-shop.oss-cn-hangzhou.aliyuncs.com/index.css`
      return getCSSString(url).then(style => {
        chalk = style
        resolve()
      })
    } else {
      resolve()
    }
  })
  .then(() => {
    return new Promise(function (resolve, reject) {
      const oldColor = chalk ? store.getters.themeColor : ORIGINAL_THEME
      if (oldColor === newColor) {
        // 颜色相同直接成功
        resolve()
      }
      const themeCluster = getThemeCluster(newColor.replace('#', ''))
      const originalCluster = getThemeCluster(oldColor.replace('#', ''))
      const chalkHandler = getHandler(chalk, 'chalk-style', themeCluster)
  
      chalkHandler()
  
      const styles = [].slice.call(document.querySelectorAll('style'))
        .filter(style => {
          const text = style.innerText
          return new RegExp(oldColor, 'i').test(text) && !/Chalk Variables/.test(text)
        })
      styles.forEach(style => {
        const { innerText } = style
        if (typeof innerText !== 'string') return
        style.innerText = updateStyle(innerText, originalCluster, themeCluster)
      })
      
      store.commit('theme/setThemeColor', newColor)
      resolve()
    })
  })
}

export function initThemeColor() {
  const savedColor = store.getters.themeColor
  if (savedColor) {
    return changeThemeColor(savedColor)
  }
  return Promise.resolve()
}